import { MasterInfoEnum } from '@/constant';
import { TGetCommonListResponse } from '@/services';
import {
	CommonActions,
	CommonSelectors,
	useAppDispatch,
	useAppSelector,
} from '@/stores';
import { useCallback, useEffect, useMemo } from 'react';

import { DefaultOptionType } from 'antd/es/select';

import { AnyObject } from 'yup';

export const useCommonList = <TCommonList>(
	type?: MasterInfoEnum,
	shouldCallApi: boolean = true,
	paramsSearch?: AnyObject,
	callback?: ({
		data,
		error,
	}: {
		data?: TGetCommonListResponse;
		error?: any;
	}) => void
) => {
	const dispatch = useAppDispatch();
	const selectMasterInfo = useAppSelector(CommonSelectors.selectMasterInfo);
	const commonList = useAppSelector(CommonSelectors.commonList);

	const selectList = useMemo(() => {
		if (type && selectMasterInfo[type]) {
			return selectMasterInfo[type] as {
				fetching: boolean;
				data: DefaultOptionType[];
				total: number;
			};
		}
		return { fetching: false, data: [] };
	}, [selectMasterInfo, type]);

	const dataList = useMemo(() => {
		if (type && commonList[type]) {
			return commonList[type] as {
				fetching: boolean;
				data: TCommonList[];
				total: number;
			};
		}
		return { fetching: false, data: [], total: 0 };
	}, [commonList, type]);

	const params = useMemo(() => {
		return paramsSearch ? paramsSearch : {};
	}, [paramsSearch]);

	useEffect(() => {
		if (type && shouldCallApi) {
			dispatch(CommonActions.getListCommonRequest({ type, params, callback }));
		}
	}, [type, shouldCallApi, JSON.stringify(params)]);

	const fetchData = useCallback(
		(enhanceParams = {}) => {
			if (type) {
				dispatch(
					CommonActions.getListCommonRequest({
						type,
						params: { ...params, ...enhanceParams },
						callback,
					})
				);
			}
		},
		[type, params, callback]
	);

	return {
		selectMasterInfo: selectList,
		commonList: dataList,
		fetchData,
	};
};
